import $ from "jquery";

$(document).ready(function () {

    $('.slider-range').each(function () {
        let $slider       = $(this);
        let $parent       = $slider.closest('.slider-range-holder');
        let min           = parseInt($slider.data('min'));
        let max           = parseInt($slider.data('max'));
        let values        = $slider.data('value').split(',');
        let valMin        = parseInt(values[0]);
        let valMax        = parseInt(values[1]);
        var externalLabel = $parent.find('.label-value');
        let options       = {
            range : true,
            min   : min,
            max   : max,
            step: 25,
            values: [valMin, valMax],
            slide : function (event, ui) {
                externalLabel.text("$" + ui.values[0] + " - $" + ui.values[1]);
                $('#min_price').val(ui.values[0]);
                $('#max_price').val(ui.values[1]);
            }
        };
        initUISlider($slider, options);
    });

    const $sliderGallery = $('.js-slider-gallery');
    $sliderGallery.each(function () {
        let $this         = $(this);
        let sliderOptions = {
            arrows        : true,
            infinite      : true,
            dots          : false,
            slidesToShow  : 1,
            slidesToScroll: 1,
            prevArrow     : $this.closest('.slider').find('.slider__prev'),
            nextArrow     : $this.closest('.slider').find('.slider__next')
        };
        initSlider($this, sliderOptions);
    });

    $('.section-results').on('click', '.paginate-li:not(.active) a.paginate', function (e) {
        var newPage = $(this).attr('data-page');
        renderNewPageContent(newPage);
    });

    $('.section-results').on('click', '.paginate.prev', function (e) {
        var currentPage = parseInt($('.paginate-li.active .paginate').attr('data-page')) - 1;
        renderNewPageContent(currentPage);
    });

    $('.section-results').on('click', '.paginate.next', function (e) {
        var currentPage = parseInt($('.paginate-li.active .paginate').attr('data-page')) + 1;
        renderNewPageContent(currentPage);
    });

    let $from = $('#field-date-from');
    let $to   = $('#field-date-to');
    const setCalsClearButton = function (year, month, elem) {
        const afterShow = function () {
            let d = new $.Deferred();
            let cnt = 0;
            setTimeout(function () {
                if (elem.dpDiv[0].style.display === "block") {
                    d.resolve();
                }
                if (cnt >= 500) {
                    d.reject("datepicker show timeout");
                }
                cnt++;
            }, 10);
            return d.promise();
        }();

        afterShow.done(function () {
            $('.ui-datepicker').css('z-index', 2000);
            const buttonPane = $(elem).datepicker("widget").find(".ui-datepicker-buttonpane");
            let btn = $('<button class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all" style="margin-left: 2em;" type="button">Clear</button>');
            btn.off("click").on("click", function () {
                $.datepicker._clearDate(elem.input[0]);
            });
            btn.appendTo(buttonPane);
        });
    }

    var datepickerOption = {
        defaultDate: "+1w",
        dateFormat: getDateFormat(),
        numberOfMonths: 1,
        minDate: new Date(),
        firstDay: 1,
        showButtonPanel: true,
        closeText: 'Close',
        beforeShow: function (inst, elem) {
            setCalsClearButton(null, null, elem);
        },
        beforeShowDay: function beforeShowDay(date) {
            var fromValue = getDate($from[0]);
            var toValue = getDate($to[0]);
            var dateClass = '';

            if (fromValue != null && toValue != null) {
                if (fromValue <= date && toValue >= date) {
                    dateClass = 'highlight';
                }
            }
            return [true, dateClass];
        }
    };

    $from.datepicker(datepickerOption).on('change', function () {
        $to.datepicker('option', 'minDate', getDate(this));
    });

    $to.datepicker(datepickerOption).on('change', function () {
        $from.datepicker('option', 'maxDate', getDate(this));
    });
});

function renderNewPageContent(page) {
    $.getJSON(window.location.href, {page: page}, function (response) {
        if (response.content) {
            $('.section-results').empty().append(response.content);
            $("html, body").animate({
                scrollTop: $('.wrapper').offset().top
            }, 600);
        }
    });
}

function getDate(element) {
    var date;
    try {
        date = $.datepicker.parseDate(getDateFormat(), element.value);
    } catch (error) {
        date = null;
    }
    return date;
}

function initUISlider($slider, sliderOptions) {
    $slider.slider(sliderOptions);
}

function getDateFormat() {
    return "dd/mm/yy";
}
